module.exports = __webpack_public_path__ + "static/media/offline_screenshot_ru.372b14b2.png";